import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';

@Component({
  selector: 'app-contact-request',
  templateUrl: './contact-request.component.html',
  styleUrls: ['./contact-request.component.scss'],
})
export class ApgContactRequestComponent implements OnInit, OnDestroy {
  
  @Input() name: string;
  @Input() error: string;

  @ViewChild(NgForm) form: NgForm;

  @Output() back = new EventEmitter();
  @Output() continue = new EventEmitter<QQQuestionnaireViewModel>();

  questionnaire: QQQuestionnaireViewModel;
  dispose$ = new Subject();
  validationRetryCount: number = 0;
  loading = false;

  get page() {
    return this.questionnaire?.currentPage;
  }

  constructor(
    private questionnaireService: QuestionnaireService
  ) {
  }

  async ngOnInit() {
    this.error = null;
    this.questionnaire = await this.questionnaireService.getQuestionnaireViewModel(this.name, false);
    this.questionnaire.pages.forEach(p => p.onQuestionAnswered.subscribe(x => this.error = null));
  }

  ngOnDestroy(): void {
    this.dispose$.next(null);
  }

  async next() {
    this.continue.emit(this.questionnaire);
  }
}
